import { render, staticRenderFns } from "./editVideo.vue?vue&type=template&id=893ba902"
import script from "./editVideo.vue?vue&type=script&lang=js"
export * from "./editVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports